import React from "react";
import AccessRestrictedMessage from "../restrictedRoute/AccessRestrictedMessage";
import { type RolePermissions } from "enums";
import Restricted from "../../features/Application/Restricted";

export type RestrictedResourceProps =
  | {
      isAuthorized: boolean;
    }
  | {
      permissions: RolePermissions[];
    };

function RestrictedResource(props: React.PropsWithChildren<RestrictedResourceProps>) {
  if ("isAuthorized" in props) {
    const { children, isAuthorized } = props;
    return isAuthorized ? children : <AccessRestrictedMessage />;
  }
  const { permissions, children } = props;
  return (
    <Restricted permissions={permissions} placeholder={<AccessRestrictedMessage />}>
      <>{children}</>
    </Restricted>
  );
}

export default RestrictedResource;
